export interface GSUserContext {
  id: string;
  domain: string;
  email: string;
  company: string;
  raBusinessPartnerID: string;
}

export type GSOrgContext = {
  organizationId: string;
  organizationName: string;
};

export enum GSEventName {
  ApplicationCard = 'CardClicked',
  ApplicationCardInfo = 'CardInfoClicked',
  EntitlementApplied = 'EntitlementApplied',
  BundleTrialRedeemed = 'BundleTrialRedeemed',
  PostLoginUnallocatedEntitlements = 'PostLoginUnallocatedEntitlements',
  SignalRDisconnectedPopup = 'SignalRDisconnectedPopup',
}

export type GSEvent = {
  eventName: GSEventName;
  eventPayload: any;
};
